// Ce context est uniquement utilisé lorsque l'organisme existe, donc il est non-null
import {OrganismeDetailsDto} from "@common/services";
import {createContext, useContext} from "react";

export const OrganismeDetailsContext = createContext<OrganismeDetailsDto>(null!);

export const useOrganismeDetailsContext = () => useContext(OrganismeDetailsContext);